import { EmployeeType, RolesNames } from '../models/employee';
import { ViewMode } from '../models/preferences';
import { generateYearOptions } from '../services/holidayService';

export const ONE_DAY_SECONDS = 24 * 60 * 60;
export const TEN_MIN_SECONDS = 10 * 60;
export const TARGET_FULL_TIME_HOURS = 8;
export const TARGET_HOURS_WEEK = 40;

export const COUNTRY_OPTIONS = [
  { label: 'Romania', id: 'Romania' },
  { label: 'Moldova', id: 'Moldova' },
  { label: 'Spain', id: 'Spain' },
  { label: 'India', id: 'India' },
  { label: 'United States', id: 'United States' },
  { label: 'Italy', id: 'Italy' },
  { label: 'Philippines', id: 'Philippines' },
  { label: 'Portugal', id: 'Portugal' },
];

export const COUNTRIES = { MOLDOVA: 'Moldova', ROMANIA: 'Romania' };

export const YEAR_OPTIONS = generateYearOptions();

export const DEFAULT_PAGE_SIZE = 15;

export const NO_PROJECTS = 'No projects found';
export const NO_TASKS = 'No tasks found';
export const NO_DEPARTMENTS = 'No departments found';
export const NO_TEAM_LEADS = 'No team leads found';
export const NO_CLIENTS = 'No clients found';
export const NO_BUDGET_OWNERS = 'No backup project managers found';
export const NO_PROJECT_MANAGERS = 'No project managers found';
export const NO_TOWERS = 'No towers were found';
export const NO_USERS = 'No users found';
export const NO_MANAGERS = 'No managers found';
export const NO_EMPLOYEES = 'No employees found';
export const NO_RESULTS = 'No results found';

export const PLEASE_TYPE = 'Please type...';

export const NUMERIC_ONLY = 'Please enter only digits';
export const NUMERIC_HALF_INCREMENTS_ONLY =
  'Only integer or increments of 0.5 are allowed.';

export const minutesActivityOptions = ['30'];

export const viewModeOptions = [
  {
    label: ViewMode.DAY,
    value: ViewMode.DAY,
  },
  {
    label: ViewMode.MONTH,
    value: ViewMode.MONTH,
  },
  {
    label: ViewMode.WEEK,
    value: ViewMode.WEEK,
  },
  {
    label: ViewMode.WORK_WEEK,
    value: ViewMode.WORK_WEEK,
  },
  {
    label: ViewMode.OLD_VIEW,
    value: ViewMode.OLD_VIEW,
  },
];

export const contractTypeOptions = [
  {
    label: 'Employee',
    value: EmployeeType.EMP,
  },
  {
    label: 'Contractor',
    value: EmployeeType.CWR,
  },
];

export const employeeRoleOptions = [
  {
    label: RolesNames.PROJECT_MANAGER,
    value: '7097af03-4e5b-4d0e-33d6-08dad2de603e',
  },
  {
    label: RolesNames.SALES_MANAGER,
    value: 'b4341d76-2961-4517-33d7-08dad2de603e',
  },
  {
    label: RolesNames.TEAM_LEAD,
    value: '3e56eea7-91ca-4321-33d5-08dad2de603e',
  },
  {
    label: RolesNames.ADMIN,
    value: '28999960-6682-4f90-33d3-08dad2de603e',
  },
];
